import { useTasksStore } from '../stores/tasks.store'
import { dbgEvent } from '../lib/debug'

/**
 * Handler des progressions de tache (visibilite des Cowboys, operation #31513).
 *
 * Derive de routeTerminal() sur le modele EXACT de metricsHandler : le canal terminal:{sid} porte
 * DEUX noms d'event, 'terminal' (vers terminalHandler) et 'task_progress' (vers ce handler).
 * routeTerminal distingue par le NOM d'event ; une progression ne va NULLE PART ailleurs — surtout
 * PAS dans liveEvents (regime B ephemere, sans seq : jamais persistee, jamais confirmee, donc jamais
 * elaguee — c'est la condition qui rend le regime sur, cf. brief §4bis etage 5).
 *
 * Ce handler n'ecrit QUE le tasks.store, jamais le terminal.store.
 */

// Charge utile diffusee par le serveur pour l'event 'task_progress' (envelope { event, data }).
// Miroir de TaskProgressPayload cote serveur, + eventId ajoute a la diffusion. Champs SDK a
// l'identique. Type local (le client n'importe pas les types serveur/protocole a l'execution).
interface TaskProgressData {
  type?: string
  sessionId?: string
  taskId: string
  description?: string
  subagent_type?: string
  usage?: { total_tokens: number; tool_uses: number; duration_ms: number }
  last_tool_name?: string
  summary?: string
  [key: string]: unknown
}

export const tasksHandler = {
  onTaskProgress(sessionId: string, data: TaskProgressData): void {
    if (!data.taskId) return
    dbgEvent('Zustand', 'tasks.onTaskProgress', { sessionId: sessionId.slice(0, 8), taskId: data.taskId })
    useTasksStore.getState().progressTask(sessionId, data.taskId, {
      description: data.description,
      subagent_type: data.subagent_type,
      usage: data.usage,
      last_tool_name: data.last_tool_name,
      summary: data.summary,
    })
  },
}
